import { axiosInstance } from "../axiosInstance";

export const getLookupsByValue = async (value, searchTerm) => {
    try 
    {
    console.log(`${value} received service`)

        const params = new URLSearchParams();
        if (searchTerm) params.append("q", searchTerm);
        const { data } = await axiosInstance.get(`api/Lookups/${value}/options?${params.toString()}`)
        return data;
    }
    catch(error)
    {
        throw error;
    }
}